/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Staff BFF
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpResponse,
  http
} from 'msw';
import type {
  RequestHandlerOptions
} from 'msw';

import type {
  OfferDetail,
  OfferListPage
} from '../schemas';

import {
  getGetOfferResponseMock,
  getListOffersResponseMock
} from './offers.faker';

export { getListOffersResponseMock, getGetOfferResponseMock } from './offers.faker';


export const getListOffersMockHandler = (overrideResponse?: OfferListPage | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<OfferListPage> | OfferListPage), options?: RequestHandlerOptions) => {
  return http.get('*/api/v1/offers', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getListOffersResponseMock(),
      { status: 200
      })
  }, options)
}

export const getGetOfferMockHandler = (overrideResponse?: OfferDetail | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<OfferDetail> | OfferDetail), options?: RequestHandlerOptions) => {
  return http.get('*/api/v1/offers/:offerId', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetOfferResponseMock(),
      { status: 200
      })
  }, options)
}
export const getOffersMock = () => [
  getListOffersMockHandler(),
  getGetOfferMockHandler()]
